import deckLog from '../utils/log';
import { getLoggers } from './loggers';
let loggers = {};

if (process.env.NODE_ENV !== 'production') {
  loggers = getLoggers(deckLog);
}

export function register(handlers) {
  loggers = handlers;
}
export default function debug(eventType) {
  if (deckLog.level > 0 && loggers[eventType]) {
    loggers[eventType].call(...arguments);
  }
}
//# sourceMappingURL=index.js.map